export default "__VITE_ASSET__XkLl_EWJ__"